import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('clientDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_CLIENT: t('editClient'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
